import React, { useEffect, useState, useRef } from "react";
import "./Login.scss";
import { useDispatch, useSelector } from "react-redux";

import axios from 'util/axios';

import { useNavigate, useLocation } from "react-router-dom";

import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";

import { useTranslation } from "react-i18next";

import { userAuthCF } from "util";

const AutoLogin = () => {
    const { t } = useTranslation(["page"]);
    const oktaLoginBtn = useRef(null);
    const { oktaAuth, authState } = useOktaAuth();

    const [inputs, setInputs] = useState({
        userId: null,
        password: null,
    });

    const { userId, password } = inputs;

    const navigate = useNavigate();
    const location = useLocation();

    const [incorrect, setIncorrect] = useState(false);

    const userSelector = useSelector((store) => store.user);

    const onChange = (e) => {
        setIncorrect(false);
        const { value, name } = e.target;
        setInputs((i) => ({
            ...i,
            [name]: value,
        }));
    };

    const dispatch = useDispatch();

    const loginValidate = () => {
        return !!userId && !!password;
    };

    const login = async () => {
        if (!loginValidate()) {
            setIncorrect(true);
            return;
        }
        try {
            const response = await axios
                .post(process.env.REACT_APP_API + "/user/userLogin", {
                    userId,
                    password,
                })
                .then((Response) => Response.data.data.result)
                .catch((e) => {
                    window.alert("Login Error");
                    throw new Error(e);
                });
            if (response) {
                let { userId, userNm, userAuth } = response;
                userAuth = JSON.parse(userAuth);
                dispatch({ type: "LOGIN", userId, userNm, userAuth, ...userAuthCF(userAuth), loginType: "own" });
                navigate("/", { replace: true });
            } else {
                setIncorrect(true);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const oktaLogin = () => {
        dispatch({
            type: "LOGIN",
            userId: null,
            userNm: null,
            userAuth: null,
            ...userAuthCF(),
            loginType: "okta",
        });
        const originalUri = toRelativeUrl(window.location.origin, window.location.origin);

        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();

    };

    useEffect(() => {
        oktaLoginCheck();
        // oktaLogin();
        // if (location.state?.type === "okta") {
        //     oktaLoginCheck();
        // } else if (userSelector.loginType === "okta") {
        //     oktaLoginCheck();
        // } else {
        //     loginCheck()
        // }
    }, []);

    const oktaLoginCheck = async () => {
        dispatch({ type: "LOADING_ON" });
        try {
            const user = await oktaAuth.getUser();
            // const userId = user.email.split("@")[0];
            //2025.11.18 변경 - 로그인시 email을 가져오면 user ID와 다른 값을 가질 수도 있어서 문제가 발생함.
            const userId = user.preferred_username.split("@")[0];
            const userNm = user.name;

            const response = await axios
                .post(process.env.REACT_APP_API + "/user/userOKTALogin", {
                    userId,
                    userNm,
                })
                .then((Response) => Response.data.data.result)
                .catch((e) => {
                    throw e;
                });
            console.log(response);
            if (response) {
                let { userId, userNm, userAuth } = response;
                try {
                    userAuth = JSON.parse(userAuth);
                    dispatch({
                        type: "LOGIN",
                        userId,
                        userNm,
                        userAuth,
                        loginType: "okta",
                        ...userAuthCF(userAuth),
                    });
                    navigate("/", { replace: true });
                } catch (e) {
                    window.location.replace("/noauth")
                }
            } else {
                oktaLogin();
            }
        } catch (e) {
            console.error(e);
        }

        dispatch({ type: "LOADING_OFF" });
    };

    const loginCheck = async () => {
        dispatch({ type: "LOADING_ON" });
        const response = await axios
            .post(process.env.REACT_APP_API + "/user/loginCheck")
            .then((Response) => Response.data.data.result)
            .catch((e) => console.error(e));
        if (response) {
            let { userId, userNm, userAuth } = response;
            userAuth = JSON.parse(userAuth);
            dispatch({ type: "LOGIN", userId, userNm, userAuth, ...userAuthCF(userAuth), loginType: "own" });

            window.location.replace("/");
        }
        dispatch({ type: "LOADING_OFF" });
    };
    return (
        <div className="login_main">
            
        </div>
    );
};

export default AutoLogin;
